<template>
  <div class="register">
    <div class="top">
      <van-icon size="22px" name="arrow-left" @click="back" />
      <span class="title">{{ $t('append_field.register')}}</span>
    </div>
    <div class="error-msg">{{$t('append_field.enter_invCode')}}</div>
    <van-form ref="from">
      <van-cell-group>
        <van-field
            :clearable="true"
            v-model="clients.inviteCode"
            :label="$t('append_field.invCode')"
            :placeholder="$t('append_field.tip_invitation_empty')"
            :rules="[{ required: true }]"
        >
          <template #label>
            <span class="required">*</span> {{ $t('append_field.invCode') }}
          </template>
        </van-field>
        <van-field
            :clearable="true"
            v-model="clients.userName"
            :label="$t('append_field.userName')"
            :placeholder="$t('append_field.enter_userName')"
            :rules="[{ required: true }]"
        >
          <template #label>
            <span class="required">*</span> {{ $t('append_field.userName') }}
          </template>
        </van-field>
        <van-field
            v-if="environment()==='local'"
            :clearable="true"
            v-model="clients.phone"
            :label="$t('append_field.phone_number')"
            :placeholder="$t('append_field.enter_phone_number')"
            :rules="[{ required: true}]"
        >
          <template #label>
            <span class="required">*</span> {{ $t('append_field.phone_number') }}
          </template>
        </van-field>
        <van-field
            v-if="environment()==='oversea'"
            :clearable="true"
            v-model="clients.email"
            :label="$t('append_field.email')"
            :placeholder="$t('append_field.enter_email')"
            :rules="[{ required: true }]"
        >
          <template #label>
            <span class="required">*</span> {{ $t('append_field.email') }}
          </template>
        </van-field>
        <van-field
            :clearable="true"
            v-model="clients.password"
            :label="$t('append_field.password')"
            :placeholder="$t('append_field.enter_password')"
            :rules="passwordRules"
        >
          <template #label>
            <span class="required">*</span> {{ $t('append_field.password') }}
          </template>
        </van-field>
        <van-field
            :clearable="true"
            v-model="clients.newpwass"
            :label="$t('append_field.confirm_password')"
            :placeholder="$t('append_field.enter_password_again')"
            :rules="newpwassRules"
        >
          <template #label>
            <span class="required">*</span> {{ $t('append_field.confirm_password') }}
          </template>
        </van-field>
        <van-field
            :clearable="true"
            v-model="clients.name"
            :label="$t('append_field.company_name')"
            :placeholder="$t('append_field.enter_company_name')"
            :rules="[{ required: true }]"
        >
          <template #label>
            <span class="required">*</span> {{ $t('append_field.company_name') }}
          </template>
        </van-field>
        <van-field
            :clearable="true"
            v-model="clients.addr"
            :label="$t('append_field.address')"
            :placeholder="$t('append_field.enter_address')"
            :rules="[{ required: true }]"
        >
          <template #label>
            <span class="required">*</span> {{ $t('append_field.address') }}
          </template>
        </van-field>
        <div style="display: flex; margin-right: 15px">
          <van-field
              :label="$t('append_field.verification_code')"
              v-model="clients.verifyCode"
              :clearable="true"
              :placeholder="$t('append_field.input_code')"
              :rules="[{ required: true}]"
          >
            <template #label>
              <span class="required">*</span> {{ $t('append_field.verification_code') }}
            </template>
            <template #button>
              <codeKey ref="codeKey" slot="append" @update:uuid="setUuid" style="display: flex; align-items: center; justify-content: center"></codeKey>
            </template>
          </van-field>
        </div>
      </van-cell-group>
      <div class="login-btn">
        <van-button block color="#006EFF" @click="addManage">
          {{$t('append_field.register')}}
        </van-button>
      </div>
    </van-form>

  </div>
</template>

<script>
import qs from "qs";
import {Toast} from 'vant'
import codeKey from "@/components/Vsidentify.vue";
import {environment} from "@/assets/js/user_environment";
const CryptoJS = require("crypto-js")

function encrypt (data) {
  var key = '79697368656e67746563686e6f6c6f6779636f6d70616e793230313930343131'
  key = CryptoJS.enc.Hex.parse(key)
  let iv = CryptoJS.enc.Hex.parse('79697368656e67746563684032303139')
  var enc = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  var enced = enc.ciphertext.toString()
  return enced
}
export default {
  name: "Register",
  components: {codeKey},

  data() {

    return {
      loading: false, // 防止连续点击
      codeTest: this.$t('login.getCode'),
      code: 0,
      clients: {
        inviteCode: '',
        name: '', // 姓名公司名称
        userName: '', // 客户账户
        addr: '',
        password: '',
        newpwass: '',
        phone: '', // 手机号码
        email:'',
        uuid: '',
        verifyCode:''
      },
      passwordRules: [
        { required: true },
        { validator: this.validatePassword, message: this.$t('append_field.please_enter_password') }
      ],
      newpwassRules:[
          { required: true },
          { validator: this.validateNewpwass, message: this.$t('append_field.passwords_do_not_match') }
      ]
    }
  },
  mounted() {
    this.setUuid()
    document.title = this.$t('append_field.register')
  },
  methods: {
    validatePassword(value) {
      // 密码验证规则：至少8个字符，包含数字、字母和特殊字符[@#$%^&+=]
      const passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@#$%^&+=]).{8,}$/
      return passwordPattern.test(value)
    },
    validateNewpwass(value) {
      if(this.clients.password===value){
        return true
      }else {
        return false
      }
    },
    environment() {
      return environment
    },
    setUuid(newUuid) {
      this.clients.uuid = newUuid
    },
    onClickLeft(){
      this.$router.go("-1")
    },
    addManage () {
     if(this.clients.password!==this.clients.newpwass){
       Toast(this.$t('append_field.passwords_do_not_match'))
       return
     }
     this.$ajax({
            url: '/etv/registerPersoner.json',
            method: 'post',
            data: {
              userInfo: encrypt(JSON.stringify(this.clients)),
            },    //this.clients,
            cache: false,
            transformRequest: [function (data) {
              if (data instanceof FormData) {
                return data
              }
              data = qs.stringify(data)
              return data
            }],

          }).then(res => {
            if (res.data.code === 0) {
              Toast(res.data.msg)
              this.$router.replace("/login")
            } else {
              this.$refs.codeKey.getCode()
              Toast(res.data.msg)
            }
          })
    },
    back() {
      this.$router.back()
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../public/static/css/app";
.register{
  overflow-y: auto;
  .top{
    padding:18px 10px;
    display: flex;
    align-items: center; /* 垂直居中对齐 */
    justify-content: center; /* 水平居中对齐 */
    position: relative; /* 使子元素可以相对于父元素定位 */
    border-bottom: #8c8c8c 1px solid;

    .van-icon {
      position: absolute; /* 绝对定位 */
      left: 10px; /* 根据需要调整左边距 */
    }
    .title{
      font-size: 18px;
      font-size: 18px;
      float: none; /* 确保不使用浮动 */
      display: inline-block; /* 使元素成为行内块级元素 */
    }
  }
  .error-msg {
    height: 35px;
    font-size:  15px;
    color: red;
    padding:5px 0 0 16px;
  }
  .van-cell{
    display: flex;
    flex-direction: column;

  }
  .required{
    color: #ff0000;
  }
  ::v-deep .s-canvas{
    width: 100%;
  }
  ::v-deep .van-field__label{
    width: auto;
  }
}
.login-btn {
  padding: 0 40px;
  margin: 15px 0;

  .landing {
    border-radius: 3px;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 3px;
    color: $uni-text-color-inverse;
    background: $uni-color-primary;
  }
}
</style>
